import BaseApi from './BaseApi'

class AgencyManagerApi extends BaseApi {
  getAgency () {
    return this.get(`agency`)
  }

  editAgency (agencyEditedObj) {
    return this.put(`agency`, agencyEditedObj)
  }

  createAgent (agentCreationObj) {
    return this.post(`agency/agents`, agentCreationObj)
  }

  getAgent (agentId) {
    return this.get(`agency/agents/${agentId}`)
  }

  editAgent (agentId, agentObject) {
    return this.put(`agency/agents/${agentId}`, agentObject)
  }

  downloadStatement (month) {
    const url = `commissions/generate`
    const method = 'post'
    const data = { month }
    return this.downloadAsFile(
      { url, method, data },
      'application/pdf',
      `${month}.pdf`
    )
  }

  disableAgent (agentId) {
    return this.post(`agents/${agentId}/disable`)
  }

  enableAgent (agentId) {
    return this.post(`agents/${agentId}/enable`)
  }
}

export default new AgencyManagerApi()
